import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


const STATUS = { promo: 'promoStatus', new: 'newStatus' }

export const fetchCardsSlice = createAsyncThunk(
   'promo/fetchCardsSlice',
   async (type, thunkAPI) => {
      try {
         const response = await API.get(`/cardsSlice`, { params: { type: type } })
         return response.data
      } catch (err) {
         thunkAPI.dispatch(setError({ action: 'fetchCardsSlice', code: err.response.status, message: err.message }))
         return thunkAPI.rejectWithValue()
      }
   },
   {
      condition: (type, { getState }) => {
         const { promo } = getState()
         const status = promo[STATUS[type]]
         if (status === 'loading' || status === 'success') return false
      }
   }
)

const initialState = {
   promo: {},
   new: {},
   promoStatus: 'init',
   newStatus: 'init'
}

const promoSlice = createSlice({
   name: 'promo',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchCardsSlice.pending, (state, action) => {
         const type = action.meta.arg
         state[STATUS[type]] = 'loading'
      })
      builder.addCase(fetchCardsSlice.fulfilled, (state, action) => {
         const type = action.meta.arg
         state[STATUS[type]] = 'success'
         state[type] = action.payload
      })
      builder.addCase(fetchCardsSlice.rejected, (state, action) => {
         const type = action.meta.arg
         state[STATUS[type]] = 'error'
      })
   }
})

export const promo = promoSlice.reducer
